import { render, staticRenderFns } from "./HistoryDisburse.vue?vue&type=template&id=66868d9d"
import script from "./HistoryDisburse.vue?vue&type=script&lang=js"
export * from "./HistoryDisburse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports